export const highlightedLabs = [
  {
    id: 1,
    title: 'SQL Injection Mastery',
    description: 'Exploit and defend against SQL injection vulnerabilities in a live web app environment.',
    category: 'Web Security',
    difficulty: 'Intermediate',
    duration: '45 min',
    completions: '18.3K',
    image: 'https://public.readdy.ai/ai/img_res/b3ca9979e78a499db6f988f08ebc017e.jpg',
    tag: 'Popular',
  },
  {
    id: 2,
    title: 'Network Packet Analysis',
    description: 'Capture and analyze network traffic to identify intrusions and suspicious patterns.',
    category: 'Network Security',
    difficulty: 'Advanced',
    duration: '60 min',
    completions: '9.7K',
    image: 'https://readdy.ai/api/search-image?query=abstract%20network%20topology%20visualization%20with%20glowing%20nodes%20and%20data%20packets%20flowing%20through%20dark%20background%2C%20cybersecurity%20monitoring%20aesthetic%2C%20teal%20and%20green%20highlights%2C%20no%20people&width=800&height=450&seq=lab-img-002&orientation=landscape',
    tag: 'New',
  },
  {
    id: 3,
    title: 'Linux Privilege Escalation',
    description: 'Learn common privilege escalation techniques on Linux systems used in penetration testing.',
    category: 'Penetration Testing',
    difficulty: 'Advanced',
    duration: '90 min',
    completions: '12.1K',
    image: 'https://readdy.ai/api/search-image?query=glowing%20terminal%20command%20line%20interface%20on%20dark%20background%20with%20Linux%20shell%20commands%2C%20cybersecurity%20hacking%20aesthetic%2C%20green%20text%20on%20black%2C%20matrix%20style%2C%20no%20people%2C%20abstract&width=800&height=450&seq=lab-img-003&orientation=landscape',
    tag: 'Hot',
  },
  {
    id: 4,
    title: 'XSS Attack & Defense',
    description: 'Understand cross-site scripting attacks and implement robust defenses in web applications.',
    category: 'Web Security',
    difficulty: 'Beginner',
    duration: '30 min',
    completions: '24.5K',
    image: 'https://readdy.ai/api/search-image?query=abstract%20web%20browser%20security%20visualization%20with%20glowing%20code%20injection%20patterns%2C%20dark%20background%20with%20orange%20and%20red%20warning%20highlights%2C%20cybersecurity%20themed%2C%20no%20people&width=400&height=300&seq=lab-img-004&orientation=landscape',
    tag: 'Beginner',
  },
  {
    id: 5,
    title: 'Cryptography Fundamentals',
    description: 'Explore encryption algorithms, hashing, and PKI through hands-on cryptographic challenges.',
    category: 'Cryptography',
    difficulty: 'Beginner',
    duration: '40 min',
    completions: '15.8K',
    image: 'https://readdy.ai/api/search-image?query=abstract%20cryptography%20visualization%20with%20glowing%20encryption%20keys%20and%20binary%20patterns%20on%20dark%20background%2C%20gold%20and%20cyan%20highlights%2C%20mathematical%20symbols%2C%20no%20people&width=400&height=300&seq=lab-img-005&orientation=landscape',
    tag: 'Beginner',
  },
];

export const labFilters = ['All', 'Beginner', 'Intermediate', 'Advanced', 'New'];
